// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"1ad22500","476":"a07c780d"}[chunkId] + ".chunk.js";
};